module.exports = {"endpoint":"https://dev.hkep.com/lrs/data/xAPI/","username":"c9a40c61919948346334edac523d7225c9126aab","password":"369723b249fa201783538c3cfc95781d4a044720","allowFail":false}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xapijs/src/config/default.json
// module id = Cdsc
// module chunks = 2 3 4 5 6